import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS } from 'src/app/shared/constants/language-constants';
import { PageName } from 'src/app/shared/utils/user-roles';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import {
  IAccessDetail,
  IUnitAndAccessPoint,
  IUnitDetail,
  IUserGroupDetails,
} from '../../user-management-interfaces';
import {
  convertDateTimeFormat,
  onEnterBackSpace,
  transformPhone,
} from 'src/app/shared/utils/utility.service';
import { CONSTANTS as CONST } from 'src/app/shared/constants/constants';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
import { AddUserService } from '../add-user.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-access-detail-email',
  templateUrl: './access-detail-email.component.html',
  styleUrls: ['./access-detail-email.component.scss'],
})
export class AccessDetailEmailComponent implements OnInit, AfterViewInit {
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  selectedUnitAccessPoint: any[] = [];
  formGroup!: FormGroup;
  submited = false;
  @Input() isLoading!: boolean;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() submitToParent = new EventEmitter();
  @Input() errorMessage!: string;
  @Input() skipStepBuilding: boolean = false;
  @Input() flowType!: string;
  userType: string = '';
  @Input() userGroup?: IUserGroupDetails[];
  @ViewChild('accessDetail') accessDetail!: ElementRef;

  @ViewChild('phone') phoneInput: any;
  paste: boolean = true;
  readonly LANG_CONST = LANGUAGE_CONSTANTS;
  readonly CONST = CONST;
  PageName = PageName;
  radionButtons: any;
  maxLength = 14;
  formGroupUserDetail!: FormGroup;
  formGroupAccessDetail!: FormGroup;
  formGroupUserTypeDetail!: FormGroup;
  sharedData?: ISharedData;
  unitName: string | undefined;
  buildingName: string | undefined;
  floorName: string | undefined;
  defaultStartTime: string | undefined;
  defaultRepeatStartTime = '12:00 AM';
  defaultRepeatEndTime = '11:59 PM';
  readonly addUser = {
    user_type_component: 2,
    access_time_component: -1,
  };
  isPropertyManager: boolean = false;
  currentUnits!: IUnitDetail[];
  currentAccessPoints!: IAccessDetail[];
  currentGroups!: any[];

  constructor(
    private rootFormGroup: FormGroupDirective,
    private helperService: HelperService,
    private sharedDataService: SharedDataService,
    private addUserService: AddUserService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description get form instance
   * @returns form controls
   */
  get formInstance() {
    return this.formGroup.controls;
  }

  /**
   * @description angular hooks
   * load current select build
   * load current select unit
   * load current floor
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.localizationService.setupLocalization();
    this.defaultStartTime = this.translate.instant('ACCESS_TIME_NOW');
    this.sharedDataService.currentData.subscribe((sharedData) => {
      this.sharedData = sharedData;
    });
    if (this.flowType === CONSTANTS.CREATE_USER) {
      const floorName = this.sharedData?.selectedFloor?.floorName;
      const buildingName = this.sharedData?.selectedBuilding?.buildingName;
      const siteName = this.sharedData?.selectedSite?.siteId;
      const buildingId = this.sharedData?.selectedBuilding?.buildingId;
      const unitId = this.sharedData?.selectedUnit?.unitId;
      const accessPointId = this.sharedData?.selectedAccessPoint?.accessPointId;
      const unitName = this.sharedData?.selectedUnit?.unitName;
      const accessPointName =
        this.sharedData?.selectedAccessPoint?.accessPointName;
      this.selectedUnitAccessPoint = [
        {
          floorName,
          buildingName,
          siteName,
          buildingId,
          unitId,
          accessPointId,
          unitName,
          accessPointName,
        },
      ];
    } else {
      this.selectedUnitAccessPoint =
        this.addUserService.getSelectedFloorUnits();
    }
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.formGroupUserDetail = this.rootFormGroup.control.get(
      'userDetails'
    ) as FormGroup;
    this.formGroupAccessDetail = this.rootFormGroup.control.get(
      'accessTime'
    ) as FormGroup;
    this.formGroupUserTypeDetail = this.rootFormGroup.control.get(
      'userTypes'
    ) as FormGroup;
    this.userType = this.formGroupUserTypeDetail.controls.userType.value;

    this.isPropertyManager =
      userTypeResponse[this.userType] === CONSTANTS.PROPERTY_MANAGER_ADMIN ||
      userTypeResponse[this.userType] === CONSTANTS.PROPERTY_MANAGER_USER
        ? true
        : false;

    this.setCurrentUnitsAndAccess();
  }

  getAccessDetailButtonLength(): number {
    return this.translate.instant('ACCESS_DETAIL_SHARE_ACCESS_WITH_USER').length;
  }

  getUserAccessHeadingLength(): number {
    return this.translate.instant('ACCESS_DETAIL_USER_ACCESS').length;
  }

  /**
   * @description setCurrentUnitsAndAccess function sets the current access point
   *              filtered out from alreadySelected keys.
   * @returns void
   */

  setCurrentUnitsAndAccess() {
    this.currentAccessPoints = this.selectedUnitAccessPoint!?.filter(
      (entity) => {
        if (entity.accessPointId) {
          return entity;
        }
      }
    );

    this.currentUnits = this.selectedUnitAccessPoint!?.filter((entity) => {
      if (entity.unitId) {
        return entity;
      }
    });

    this.currentGroups = this.userGroup!?.filter((userGroup: any) => {
      return !userGroup?.alreadySelected;
    });
  }

  /**
   * @description navigation to back
   * @returns void
   */
  navigateBack(): void {
    if (
      (userTypeResponse[this.userType] === CONSTANTS.PROPERTY_MANAGER_ADMIN ||
        userTypeResponse[this.userType] === CONSTANTS.PROPERTY_MANAGER_USER) &&
      this.flowType === CONSTANTS.ADD_USER
    ) {
      this.stepperChange.emit(
        (this.stepper = this.addUser.user_type_component)
      );
    } else {
      this.stepperChange.emit(
        (this.stepper += this.addUser.access_time_component)
      );
    }
  }

  seeMoreUnitsAndAccessPoints() {
    this.stepperChange.emit((this.stepper = 8));
  }

  /**
   * @description get all child formgroup control here before submission data transform as per api needs
   * @returns void
   */
  submit(): void {
    if (!this.isLoading) {
      this.sharedDataService.checkFlag(false);
      this.submited = true;
      if (this.formGroup.invalid) return;
      this.submitToParent.emit(); //submit parent form
    }
  }
  ngAfterViewInit(): void {
    if (this.accessDetail) {
      this.accessDetail.nativeElement.focus();
    }
  }
  /**
   * @description #onInputBackSpace function trigger on phone input field and check if entered input is backspace and remove last character
   * @returns void
   */
  onInputBackSpace(ev: any): void {
    onEnterBackSpace(ev, this.phoneInput);
  }

  /**
   * @description #onRegionSelectede function trigger on phone input field and set the phone maximum length according to the selected country
   * @returns void
   */
  onRegionSelected(region: any) {
    this.maxLength = this.helperService.phoneNumberLength(region);
  }
}
